<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="primary" dark flat>
                <v-toolbar-title>{{ $vuetify.lang.t('$vuetify.user.resetPasswordConfirmForm') }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form @submit="submitResetPasswordConfirm">
                  <v-text-field
                    label="Email"
                    type="email"
                    v-model="formData.email"
                    outlined
                    prepend-icon="$vuetify.icons.user"
                  ></v-text-field>

                  <v-text-field
                    hide-details
                    :label="$vuetify.lang.t('$vuetify.user.password')"
                    prepend-icon="$vuetify.icons.lock"
                    type="password"
                    v-model="formData.new_password"
                    outlined
                  ></v-text-field>
                  <v-text-field
                    hide-details
                    :label="$vuetify.lang.t('$vuetify.user.passwordConfirm')"
                    prepend-icon="$vuetify.icons.lock"
                    type="password"
                    v-model="formData.new_password_confirmation"
                    outlined
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <div class="flex-grow-1" />

                <v-btn color="primary" @click="submitResetPasswordConfirm" :disabled="sending === true">{{
                  $vuetify.lang.t('$vuetify.user.passwordChange')
                }}</v-btn>
                <div v-if="sending" class="d-flex align-center justify-center h-100">
                  <v-progress-circular :size="25" color="white" indeterminate :width="3" />
                </div>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      formData: {},
      sending: false,
    };
  },
  methods: {
    ...mapActions('auth', { attemptLogin: 'attemptLogin' }),

    submitResetPasswordConfirm() {
      this.sending = true;
      this.formData.token = this.$route.params.token;
      axios
        .put('passwords/user', this.formData)
        .then(response => {
          if (response.status === 204) {
            this.$store.dispatch(
              'alerts/OPEN_SUCCESS',
              this.$vuetify.lang.t('$vuetify.messages.passwordChangeSuccess')
            );
            // eslint-disable-next-line
            const email = this.formData.email;
            const password = this.formData.new_password;
            this.attemptLogin({ email, password }).then(() => {
              this.$router.push({ name: 'search' });
            });
          }
          this.sending = false;
        })
        .catch(error => {
          this.sending = false;
          if (error.response.status === 429) {
            this.$store.dispatch('alerts/OPEN_ERROR', this.$vuetify.lang.t('$vuetify.messages.APICallsNumberExceeded'));
          }
          if (error.response.data.errors) {
            this.$store.dispatch('alerts/OPEN_ERROR', error.response.data.errors[0].message, {
              root: true,
            });
          } else {
            this.$store.dispatch('alerts/OPEN_ERROR', error.response.data.message, { root: true });
          }
        });
    },
  },
  created() {
    const keyDown = event => {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        this.submitResetPasswordConfirm();
        window.removeEventListener('keydown', keyDown);
      }
    };
    window.addEventListener('keydown', keyDown);
  },
};
</script>
